import { useState } from 'react';
import BuyerButton from '@/components/BuyerButton';
import SupportButton from '@/components/SupportButton';
import { useUser } from '@/contexts/AuthContext';
import { useDrawerContext } from '@/contexts/DrawerContext';
import { QuestionAnswer } from '@mui/icons-material';
import { Box, Divider, IconButton, Modal, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// declare function movideskChatWidgetChangeWindowState(input: string): void;

const styleModalDesktopDefault = (
  isAutheticatedValue: boolean,
  isDrawerOpenValue: boolean
) => ({
  position: 'relative',
  top: 135,
  right:
    isAutheticatedValue && isDrawerOpenValue
      ? -135
      : isAutheticatedValue
      ? -10
      : 20,
  width: 250,
  backgroundColor: 'background.paper',
  boxShadow: 24,
  borderRadius: '4px',
  float: 'right',
  ':before': {
    content: '""',
    width: 0,
    height: 0,
    position: 'absolute',
    top: '-14px',
    right: '30px',
    borderTop: '10px solid transparent',
    borderBottom: '10px solid transparent',
    borderLeft: '10px solid #ffffff',
    transform: 'rotate(270deg)',
  },
});

const styleModalMobileDefault = (isAutheticatedValue: boolean) => ({
  position: 'relative',
  top: 128,
  right: isAutheticatedValue ? 10 : 40,
  width: 250,
  backgroundColor: 'background.paper',
  boxShadow: 24,
  borderRadius: '4px',
  float: 'right',
  ':before': {
    content: '""',
    width: 0,
    height: 0,
    position: 'absolute',
    top: '-14px',
    right: '30px',
    borderTop: '10px solid transparent',
    borderBottom: '10px solid transparent',
    borderLeft: '10px solid #ffffff',
    transform: 'rotate(270deg)',
  },
});

interface IStyleModal {
  position: string;
  top: number;
  right: number;
  width: number;
  backgroundColor: string;
  boxShadow: number;
  borderRadius: string;
  float: string;
  ':before': {
    content: string;
    width: number;
    height: number;
    position: string;
    top: string;
    right: string;
    borderTop: string;
    borderBottom: string;
    borderLeft: string;
    transform: string;
  };
}

interface BalloonTalkBuyerSupportProps {
  styleModalDesktop?: IStyleModal;
  styleModalMobile?: IStyleModal;
  styleBoxWidth?: string;
  nbUnreadMessages: number;
}
export default function BalloonTalkBuyerSupport({
  styleModalDesktop,
  styleModalMobile,
  styleBoxWidth,
  nbUnreadMessages,
}: BalloonTalkBuyerSupportProps) {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    // movideskChatWidgetChangeWindowState('minimized');
  };
  const { isAuthenticated } = useUser();
  const { isDrawerOpen } = useDrawerContext();

  return (
    <>
      <IconButton
        sx={nbUnreadMessages > 0 ? { padding: 0 } : { mr: 1 }}
        onClick={handleOpen}
        aria-label="open-balloon-modal"
      >
        <QuestionAnswer color="primary" />
      </IconButton>
      {nbUnreadMessages > 0 && (
        <Box
          data-testid="notify-box"
          sx={{
            bgcolor: 'red',
            width: 16,
            height: 16,
            borderRadius: '50%',
            mb: 3,
            mr: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            data-testid="nbUnreadMessagesBalloon"
            variant="body2"
            align="center"
            sx={{ color: '#fff', fontWeight: 500, fontSize: '10px' }}
          >
            {nbUnreadMessages > 9 ? '9+' : nbUnreadMessages}
          </Typography>
        </Box>
      )}
      <Box>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          <Box
            data-testid="width-box"
            sx={
              smUp
                ? { width: styleBoxWidth ?? '900px', px: '25px', height: '1px' }
                : { width: '100%', height: '1px' }
            }
          >
            <Box
              sx={
                smUp
                  ? styleModalDesktop ??
                    styleModalDesktopDefault(isAuthenticated, isDrawerOpen)
                  : styleModalMobile ?? styleModalMobileDefault(isAuthenticated)
              }
            >
              <BuyerButton nbUnreadMessages={nbUnreadMessages} />
              <Divider />
              <SupportButton />
            </Box>
          </Box>
        </Modal>
      </Box>
    </>
  );
}
